<ng-container *ngIf="!bFromCompanyPage; else dialogTemplate">
<main [@fadeInOut] id="main-heading" role="main" tabindex="0">
  <div class="col-sm-12 center-block" [@fadeInOut]>
    <ng-container *ngTemplateOutlet="contactFormTemplate"></ng-container>
  </div>
</main>
</ng-container>

<ng-template #dialogTemplate>
  <div class="container-fluid" [@fadeInOut]>
    <ng-container *ngTemplateOutlet="contactFormTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #contactFormTemplate>
    <div class="row">
      <div class="col-12">
        <h2 *ngIf="!this.contact" class="h4 text-primary" tabindex="0" aria-label="Add Contact" role="heading" aria-level="2"><i class="fas fa-plus" aria-label="Add Contact"></i> Add Contact</h2>
        <h2 *ngIf="this.contact" class="h4 text-primary" tabindex="0" aria-label="Contact Name" role="heading" aria-level="2">{{this.contact.firstName}} {{this.contact.lastName}}</h2>
        <p *ngIf="this.contact" role="paragraph" tabindex="0" aria-label="Version" class="mb-3">
          Version: <span class="primary margin-right">{{this.version}}</span>
          <span *ngIf="this.contact.formActiveFlag === 'Active'" class="badge badge-success" aria-label="current">current</span>
        </p>
      </div>
    </div>

    <div class="row card-sticky" *ngIf="this.contact && this.contact.formActiveFlag !== 'Active' && this.contact.formActiveFlag !== 'Draft'">
      <div class="alert alert-warning text-center" role="alert">
        <i class="fas fa-exclamation-circle" aria-label="warning: not current version"></i>&nbsp;<b>NOT CURRENT VERSION</b> - Any changes made could overwrite a newer version of this form.
      </div>
    </div>

    <form [formGroup]="contactForm" novalidate #newUserForm="ngForm" role="form" aria-label="Contacts Form">
      <div class="row">
        <div class="mb-3 col-md-6">
          <label for="firstName"  id="firstName-label">Contact first name</label>
          <input type="text" formControlName="firstName" class="form-control required" maxlength="255"
                  [ngClass]="{ 'is-invalid': formErrors?.firstName }"
                  aria-labelledby="firstName-label" role="textbox" aria-required="true" aria-label="Enter first name"/>
          <div *ngIf="submitted && f.firstName.errors" class="alert-text">
            <div *ngIf="f.firstName.errors.required" aria-label="first name is required">Contact first name is required</div>
            <div *ngIf="f.firstName.errors.pattern" aria-label="first name is invalid">Contact first name is invalid</div>
          </div>
        </div>
        <div class="mb-3 col-md-6">
          <label for="lastName" id="lastName-label">Contact last name</label>
          <input type="text" formControlName="lastName" class="form-control required" maxlength="255"
                  [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }"
                  aria-labelledby="lastName-label" role="textbox" aria-required="true" aria-label="Enter last name"/>
          <div *ngIf="submitted && f.lastName.errors" class="alert-text">
            <div *ngIf="f.lastName.errors.required" aria-label="last name is required">Contact last name is required</div>
            <div *ngIf="f.lastName.errors.pattern" aria-label="last name is invalid">Contact last name is invalid</div>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label for="email" id="email-label">Email address</label>
        <input id="email" type="email" formControlName="email" class="form-control required" maxlength="255"
               [ngClass]="{ 'is-invalid':submitted && f.email.errors}"
               aria-labelledby="email-label" role="textbox" aria-required="true" aria-label="Enter email"/>
        <div *ngIf="submitted && f.email.errors" class="alert-text">
          <div *ngIf="f.email.errors.required" aria-label="email is required">Email address is required</div>
          <div *ngIf="f.email.errors.invalidEmail" aria-label="email is required">Email address is invalid</div>
        </div>
      </div>
      <div class="row">
        <div class="mb-3 col-md-3">
          <label for="dialCode" id="dialCode-label">Country code</label>
          <input type="text" formControlName="dialCode" class="form-control required" maxlength="10"
                 [ngClass]="{ 'is-invalid': formErrors?.dialCode }"
                 aria-labelledby="dialCode-label" role="textbox" aria-required="true" aria-label="Enter country code"/>
          <div *ngIf="submitted && f.dialCode.errors" class="alert-text">
            <div *ngIf="f.dialCode.errors.required" aria-label="country code is required">Country code is required</div>
            <div *ngIf="f.dialCode.errors.pattern" aria-label="country code is required">Country code is invalid</div>
          </div>
        </div>
        <div class="mb-3 col-md-2">
          <label for="areaCode" id="areaCode-label">Area code</label>
          <input type="text" formControlName="areaCode" class="form-control required" maxlength="25"
                 [ngClass]="{ 'is-invalid': formErrors?.areaCode }"
                 aria-labelledby="areaCode-label" role="textbox" aria-required="true" aria-label="Enter area code"/>
          <div *ngIf="submitted && f.areaCode.errors" class="alert-text">
            <div *ngIf="f.areaCode.errors.required" aria-label="area code is required">Area code is required</div>
            <div *ngIf="f.areaCode.errors.pattern" aria-label="area code is required">Area code is invalid</div>
          </div>
        </div>
        <div class="mb-3 col-md-5">
          <label for="phoneNumber" id="phoneNumber-label">Subscriber number</label>
          <input type="text" formControlName="phoneNumber" class="form-control required" maxlength="25"
                 [ngClass]="{ 'is-invalid': formErrors?.phoneNumber }"
                 aria-labelledby="phoneNumber-label" role="textbox" aria-required="true" aria-label="Enter subscriber number"/>
          <div *ngIf="submitted && f.phoneNumber.errors" class="alert-text">
            <div *ngIf="f.phoneNumber.errors.required" aria-label="subscriber number is required">Subscriber number is required</div>
            <div *ngIf="f.phoneNumber.errors.pattern" aria-label="subscriber number is required">Subscriber number is invalid</div>
          </div>
        </div>
        <div class="mb-3 col-md-2">
          <label for="phoneExt" id="phoneExt-label">Extension</label>
          <input type="text" formControlName="phoneExt" class="form-control" maxlength="255"
                 [ngClass]="{ 'is-invalid': formErrors?.phoneExt }"
                 aria-labelledby="phoneExt-label" role="textbox" aria-label="Enter extension"/>
        </div>
        <div *ngIf="submitted && f.phoneExt.errors" class="alert-text">
          <div *ngIf="f.phoneExt.errors.pattern" aria-label="extension is invalid">Extension is invalid</div>
        </div>
      </div>
      <div *ngIf="contactForm && contactForm.hasError('invalidPhoneNumber') && contactForm.touched" class="row">
        <div class="mb-3 col-md-5"></div>
        <div class="mb-3 col-md-7">
          <div class="alert-text" aria-label="subscriber number is invalid">
            Subscriber number is invalid
          </div>
        </div>
      </div>
      <div *ngIf="contactForm && contactForm.hasError('invalidAreaCode') && contactForm.touched" class="row">
        <div class="mb-3 col-md-3"></div>
        <div class="mb-3 col-md-9">
          <div class="alert-text" aria-label="area code is invalid">
            Area Code is invalid
          </div>
        </div>
      </div>

      <div class="mb-3">
        <label for="address" id="address-label">Street address</label>
        <input type="text" formControlName="address" class="form-control" maxlength="255" [required]="isAddressRequiredCompanyType()"
               [ngClass]="{required: isAddressRequiredCompanyType(), 'is-invalid': formErrors?.address }"
               aria-labelledby="address-label" role="textbox" aria-label="Enter street address"/>
        <div *ngIf="submitted && f.address.errors" class="alert-text">
          <div *ngIf="f.address.errors.required" aria-label="street address is required">Street address is required</div>
        </div>
      </div>
      <div class="mb-3">
        <label for="city" id="city-label">City</label>
        <input type="text" formControlName="city" class="form-control" maxlength="50"
               [required]="isAddressRequiredCompanyType()"
               [ngClass]="{required: isAddressRequiredCompanyType(), 'is-invalid': formErrors?.city }"
               aria-labelledby="city-label" role="textbox" aria-label="Enter city"/>
        <div *ngIf="submitted && f.city.errors" class="alert-text">
          <div *ngIf="f.city.errors.required" aria-label="city is required">City is required</div>
        </div>
      </div>
      <div class="row">
        <div class="mb-3 col-md-4">
          <label for="countryId" id="countryId-label">Country</label>
          <ejs-dropdownlist id="countryId" [dataSource]='countries' [value]="selectedCountryId" [popupWidth]='ddwWdith'
                            [fields]='countryFields' [placeholder]='countryWaterMark' [popupHeight]='ddwHeight'
                            (change)='countrySelectionChanged($event)' formControlName="countryId" showClearButton=true
                            [required]="isAddressRequiredCompanyType() && (selectedCountryId==='' || f.countryId.value==null)"
                            [ngClass]="{required:isAddressRequiredCompanyType(), 'is-invalid': formErrors?.countryId }">
          </ejs-dropdownlist>
          <div *ngIf="submitted && f.countryId.errors" class="alert-text">
            <div *ngIf="f.countryId.errors.required" aria-label="country is required">Country is required</div>
          </div>
        </div>
        <div class="mb-3 col-md-4">
          <label for="countryRegion" id="countryRegion-label">State/Province</label>
          <ejs-dropdownlist id="countryRegion" [dataSource]='regions' [value]="selectedRegionId" [popupWidth]='ddwWdith'
                            [fields]='stateFields' [placeholder]='stateWaterMark' (change)='stateSelectionChanged($event)'
                            formControlName="countryRegion" [popupHeight]='ddwHeight' showClearButton=true
                            [required]="isRequiredTypes(f.countryId.value) && f.countryId.value == COUNTRY_USA && regionFromDrp == ''"
                            [ngClass]="{required:isRequiredTypes(f.countryId.value) && f.countryId.value == COUNTRY_USA, 'is-invalid': formErrors?.countryRegion }">
          </ejs-dropdownlist>
          <div *ngIf="submitted && f.countryRegion.errors" class="alert-text">
            <div *ngIf="f.countryRegion.errors.required" aria-label="state or region is required">State/Region is required</div>
          </div>
        </div>
        <div class="mb-3 col-md-4">
          <label for="zip" id="zip-label">Postal code</label>
          <input type="text" formControlName="zip" class="form-control" maxlength="255" [required]="isAddressRequiredCompanyType()"
                 [ngClass]="{required: isAddressRequiredCompanyType(), 'is-invalid': formErrors?.zip }"
                 aria-labelledby="zip-label" role="textbox" aria-label="Enter postal code" />
          <div *ngIf="submitted && f.zip.errors" class="alert-text">
            <div *ngIf="f.zip.errors.required" aria-label="postal code is required">Postal code is required</div>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <label for="businessCategoryId">Business category</label>
        <ejs-dropdownlist id="businessCategoryId" [dataSource]='businessCategories' [value]="selectedBusinessCategoryId"
                          [fields]='businessCategoryFields' [placeholder]='businessCategoryWaterMark' showClearButton=true
                          formControlName="businessCategoryId" name="businessCategoryId" [popupHeight]='ddwHeight'
                          [ngClass]="{ 'is-invalid': formErrors?.businessCategoryId }">
        </ejs-dropdownlist>
      </div>
      <div class="row">
        <div class="mb-3 col-md-12 small-padding-top">
          <label for="status" id="status-label">Contact status</label>
          <br />
          <div class="form-check form-check-inline px-0" tabindex="0">
            <input class="form-check-input" type="radio" formControlName="status" value="Active" class="required"
            aria-labelledby="active-label" role="radiogroup" aria-label="contact status active" />
            <label class="form-check-label" id="active-label">Active</label>
          </div>
          <div class="form-check form-check-inline" tabindex="0">
            <input class="form-check-input" type="radio" formControlName="status" value="Inactive" class="required"
            aria-labelledby="inactive-label" role="radiogroup" aria-label="contact status inactive" />
            <label class="form-check-label" id="inactive-label">Inactive</label>
          </div>
          <div *ngIf="submitted && f.status.errors" class="alert-text">
            <div *ngIf="f.status.errors.required" aria-label="status is required">Status is required</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mt-3">
          <span *ngIf="!bFromCompanyPage">
            <a class="btn btn-default margin-right" (click)="cancelBtnClicked()"
            role="link" aria-label="Cancel" (keydown.enter)="cancelBtnClicked()" tabindex="0">Cancel</a>
          </span>
          <span>
            <button class="btn btn-info margin-right" (click)="setDraftMode(); saveContact(newUserForm.value)" [disabled]="!bHasPermission"
            role="button" aria-label="Save a draft" (keydown.enter)="setDraftMode(); saveContact(newUserForm.value)" tabindex="0">Save a draft</button>
          </span>
          <span>
            <button class="btn btn-primary" id="btnSaveContact" (click)="setActiveMode(); saveContact(newUserForm.value)" [disabled]="!bHasPermission"
            role="button" aria-label="Save" (keydown.enter)="setActiveMode(); saveContact(newUserForm.value)" tabindex="0">Save</button>
          </span>
          <app-delete-button #deleteContact *ngIf="bHasDeletePermission"
              [canDelete]="!!contactRevisionId"
              [revisionId]="contactRevisionId"
              [apiController]="'Contacts'"
              [isDraft]="bIsDraftMode"
              [redirectPage]="'contact-dashboard'">
          </app-delete-button>
          <span *ngIf="errorMessage!=null && errorMessage!=''" class="alert-text left-padding alert">{{errorMessage}}</span>
        </div>
      </div>
    </form>
    <div *ngIf="loading">
      <div id="loading"></div>
    </div>
</ng-template>

